import { render, staticRenderFns } from "./ShowBarChart.vue?vue&type=template&id=23ef3ca4"
import script from "./ShowBarChart.vue?vue&type=script&lang=js"
export * from "./ShowBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports